import VehicleDetailImage from './VehicleDetailImage'
import { UnwatchPlaceholder } from 'modules/Watchlist/UnwatchPlaceholder'
import { Col, Row, Form } from 'react-bootstrap'
import { IVehicleData } from '../../types/vehicleTypes'
import { StyledCarfaxCol, StyledVehicleDetailsCard } from './VehicleDetails.styled'
import { useContext } from 'react'
import { VehicleContext } from './VehicleContext'
import { VehicleInformation } from './VehicleInformation'
import { StyledVehicleDetailsColumn } from 'modules/VehicleList'
import { CarfaxAdvantage } from './CarfaxAdvantage'
import { getVdpUrl } from 'utils/urlUtils'
import { useHistory } from 'react-router-dom'
import { StockwaveData } from 'modules/Stockwave/StockwaveData'

export interface IVehicleDetailsProps {
  vehicleData: IVehicleData
  enableRemovedWatchlistPlaceholder: boolean
  onSelect?: (e: boolean) => void
  showCheckbox?: boolean
  isSelected?: boolean
  isShowRemoveBidButton?: boolean
}

export const VehicleListLayout = ({
  vehicleData,
  enableRemovedWatchlistPlaceholder,
  onSelect,
  isSelected,
  showCheckbox
}: IVehicleDetailsProps) => {
  const { vehicle: vehicleInfo } = vehicleData
  const {
    vehicleData: {
      vehicle: { WatchListID }
    }
  } = useContext(VehicleContext)

  if (!WatchListID && enableRemovedWatchlistPlaceholder) {
    return (
      <StyledVehicleDetailsCard>
        <UnwatchPlaceholder vehicleInfo={vehicleInfo}></UnwatchPlaceholder>
      </StyledVehicleDetailsCard>
    )
  }
  const handleCheckboxClick = (e: any) => {
    const { checked } = e.target as HTMLInputElement
    onSelect?.(checked)
  }

  return (
    <StyledVehicleDetailsCard>
      <Row noGutters className="stockwave-vehicle-row stockwave-highlight-element">
        <Col sm={3} className="vehicle-detail-image-section">
          <div className="stockwave-light-bulb-container" id={`vehicle_${vehicleData.vehicle.VIN}`}></div>
          <StockwaveData vehicleData={vehicleData} />
          {showCheckbox && (
            <Form.Check
              id={`vehicle-details-check-${vehicleData.vehicle.InstanceID}`}
              className="vehicle-select"
              checked={isSelected}
              custom
              onChange={handleCheckboxClick}
            />
          )}
          <VehicleDetailImage
            vehicleInstance={vehicleData.vehicle.InstanceID}
            isDSI={vehicleData.vehicle.IsSellerDisclosure}
            mainImageUrl={vehicleInfo.ThumbImageURL}
            images={vehicleInfo.Images}
          ></VehicleDetailImage>
        </Col>
        <Col>
          <StyledVehicleDetailsColumn>
            <VehicleInformation vehicleData={vehicleData}></VehicleInformation>
            <Row className="carfax-advanced-section justify-content-end">
              <StyledCarfaxCol md={12}>
                <CarfaxAdvantage snapshotList={vehicleData.carfaxSnapshotList} />
              </StyledCarfaxCol>
            </Row>
          </StyledVehicleDetailsColumn>
        </Col>
      </Row>
    </StyledVehicleDetailsCard>
  )
}
